import { Route, Routes } from 'react-router-dom'
import { TableAnalysisSalesInvoiceDetailed } from './table/table'


export const BrowserAnalysisSalesInvoicesDetailed = () => {
    return (
        <Routes>
            <Route path={"/"} element={<TableAnalysisSalesInvoiceDetailed />} />
        </Routes>
    )
}